module.exports = __webpack_public_path__ + "static/img/vip-img1.256ca94.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/vip-img1.png
// module id = cbLz
// module chunks = 1